import { ButtonBase } from "@mui/material";
import * as React from "react";

export default (props: React.PropsWithChildren) => {
	const [hover, setHover] = React.useState(false);

	return (
		<ButtonBase
			style = {{
				...(hover ? {backgroundColor: 'rgba(0,0,0,0.04)'} : null),
				width: '100%',
			}}
			onMouseEnter={()=>{
				setHover(true);
			}}
			onMouseLeave={()=>{
				setHover(false);
			}}
		>{props.children}</ButtonBase>
	);
}
